'use client';

import { observer } from 'mobx-react';
import Checkbox from '~/components/commonUi/Checkbox/Checkbox';
import { getStore } from '~/mobx/AppStore';

interface ListZipCodesProps {
    isDisabled: boolean;
    zipcodeList: string[];
    isGettingZipcode: boolean;
    zipCodesToDelete: string[];
    setZipCodesToDelete: (zipcode: string[]) => void;
}

const ListZipCodes = (props: ListZipCodesProps) => {
    const classNamesTableHeadBorder = `border-b-[3px] border-b-[#bebebe] border-t-[1px] border-t-[#dddddd]`;
    const classNamesTableHeadDefault = `bg-[#f5f5f5] text-[#83ab34] text-[82%] pl-[54px]`;
    const classNamesTableHeadCell = [classNamesTableHeadBorder, classNamesTableHeadDefault].join(' ');
    const classNamesTableRow = `hover:bg-[#e3e3e3]`;
    const classNamesTableCell = `border-b-[1px] border-b-[#dddddd]`;
    const classNamesLabel = `font-normal flex items-center cursor-pointer py-[4px]`;
    const classNamesText = `pl-[8px]`;

    const onChange = (number: string) => {
        const current = props.zipCodesToDelete ?? [];

        const updated = current.includes(number) ? current.filter((zip) => zip !== number) : [...current, number];

        props.setZipCodesToDelete(updated);
    };

    const renderZipCodes = () => {
        const items: JSX.Element[] = [];
        props.zipcodeList?.forEach((code, index) => {
            const number = code;
            const isChecked = props.zipCodesToDelete.includes(code);
            items.push(
                <tr key={`row-${index}`} className={classNamesTableRow}>
                    <td className={classNamesTableCell}>
                        {!props.isDisabled ? (
                            <Checkbox
                                key={`checkbox-${index}`}
                                test-id={`checkbox-${number}`}
                                labelClassNames={classNamesLabel}
                                textClassNames={classNamesText}
                                label={number?.toString()}
                                checked={isChecked}
                                onChange={() => onChange(number)}
                            />
                        ) : (
                            number?.toString()
                        )}
                    </td>
                </tr>
            );
        });
        return items;
    };

    const shouldRenderZipcodeList = !props.isGettingZipcode && props.zipcodeList.length > 0;

    return (
        <div className="overflow-x-auto mb-4">
            <table className="table text-[100%]">
                <thead>
                    <tr>
                        <th className={classNamesTableHeadCell}>Postnr</th>
                    </tr>
                </thead>
                <tbody>{shouldRenderZipcodeList && renderZipCodes()}</tbody>
            </table>
        </div>
    );
};

const ListZipCodesWithStore = () => {
    const { zipcodeStore, generalSettingsStore } = getStore();

    return (
        <ListZipCodes
            isDisabled={generalSettingsStore.isSettingsDisabled}
            zipcodeList={zipcodeStore.zipcodeList}
            isGettingZipcode={zipcodeStore.isGettingZipcode}
            setZipCodesToDelete={(zipcode: string[]) => zipcodeStore.setZipCodesToDelete(zipcode)}
            zipCodesToDelete={zipcodeStore.zipCodesToDelete}
        />
    );
};

export default observer(ListZipCodesWithStore);
